import { Outlet } from "react-router-dom";
import { FixedCostExtrasPanel } from "@/components/organisms";
import { Nav } from "../VehicleCategories/VehicleCategories";
import { FixedCostExtrasAdd } from "./FixedCostExtrasAdd";
import { FixedCostExtrasEdit } from "./FixedCostExtrasEdit";

export const FixedCostExtras = () => {
  return (
    <>
      <Nav />
      <FixedCostExtrasPanel />
      <Outlet />
    </>
  );
};

FixedCostExtras.Edit = FixedCostExtrasEdit;
FixedCostExtras.Add = FixedCostExtrasAdd;
